module.exports = __webpack_public_path__ + "media/images/play_button-e16adf5a5ae3d9aef6e1f6c7e59c3c83.png";